import React, { useEffect, useState } from "react";
import { Button, Form, Input, Col, Row, Typography, Space, Select } from "antd";
import {
  useSearchData,
  useWarehouseStore,
  useShippingItemsData,
} from "pages/store";

const { Text } = Typography;

function DispatchSearch({
  setAllSelectedOrders,
  setSelectedKeys,
  setSearchData,
  search,
  handleclear,
}) {
  const [form] = Form.useForm();
  const [searchLength, setSearchLength] = useState("");
  const [isSearchValue, setSearchValue] = useState(false);
  const [pageNumber] = useState("1");
  const [warehouses, setWarehouses] = useState([]);
  const [warehouse, setWarehouse] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [selectedOption, setSelectedOption] = useState(" ");
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    total: 1,
    pageSize: 10,
  });

  const { searchdata, fetchSearchData } = useSearchData();
  const { fetchWarehouseData, warehouseData } = useWarehouseStore();
  const { shippingData, fetchShippingData } = useShippingItemsData();

  const handleClick = () => {
    if (searchKey || selectedOption) {
      let query = "";
      if (search === "dashboard") {
        if (searchKey) {
          query = `searchKey=${encodeURIComponent(searchKey)}&`;
        } else if (selectedOption) {
          query = `warehouse=${selectedOption}&`;
        }
        fetchShippingData(query, pageNumber);
      } else {
        fetchSearchData(searchKey);
      }
    }
  };

  const handleClear = () => {
    form.resetFields();
    setSearchValue(false);
    setSearchLength("");
    setAllSelectedOrders([]);
    if (search === "dashboard") {
      fetchShippingData("", pageNumber);

      setWarehouse("");
      setSelectedKeys([]);
      setSelectedOption("");
    } else {
      setSearchData([]);
      handleclear();
    }
  };
  const handleChange = (value) => {
    setSelectedOption(value);
  };

  const handleValue = (value) => {
    setSearchKey(value.search);
    if (value.warehouse) {
      setWarehouse(value.warehouse);
    }
    setSearchValue(!!(value.search && value.search.trim()));
  };
  const initWarehouses = async () => {
    let warehouseOptions = [];
    try {
      if (warehouseData.length > 0) {
        warehouseOptions = warehouseData.map((warehouse) => ({
          label: warehouse.name,
          value: warehouse.id,
        }));
        warehouseOptions.push({ label: "N/A", value: "NA" });
        setWarehouses(warehouseOptions);
      }
    } catch (error) {
      console.error(error.message);
    }
  };
  useEffect(() => {
    initWarehouses();
  }, [warehouseData, setWarehouses]);
  
  return (
    <>
      <Form form={form} onValuesChange={handleValue} className="form-fixed">
        <Row>
          <Col>
            <Form.Item name="search">
              <Input
                style={{ width: 600 }}
                placeholder="Search prescription with order display Id"
                disabled={warehouse}
              />
            </Form.Item>
          </Col>
          {window.location.pathname !== "/search" && (
            <Col>
              <Form.Item name="warehouse">
                <Select
                  allowClear
                  dropdownStyle={{ minWidth: "6rem" }}
                  options={warehouses}
                  onChange={handleChange}
                  placeholder="Warehouses"
                  disabled={isSearchValue}
                  value={selectedOption}
                />
              </Form.Item>
            </Col>
          )}
          <Col>
            <Space>
              <Button
                style={{ marginLeft: "10px" }}
                type="primary"
                htmlType="submit"
                disabled={!isSearchValue && !warehouse}
                onClick={handleClick}
              >
                Search
              </Button>
              <Button
                onClick={handleClear}
                disabled={!isSearchValue && !warehouse}
              >
                Clear
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
      {searchLength && (
        <Text>{`Showing ${paginationInfo.current} out of ${paginationInfo.total} pages`}</Text>
      )}
    </>
  );
}

export default DispatchSearch;
